<template>
  <v-dialog scrollable v-model="config.status.active" max-width="600">
    <v-card>
      <v-card-title class="secondary white--text">日付を更新する</v-card-title>
      <v-card-text class="pt-4">
        <v-form ref="form" lazy-validation v-model="form.valid">
          <v-row dense>
            <v-col cols="5">
              <v-text-field readonly
                v-model="printPrevDate"
                label="現在の予定日"
              />
            </v-col>
            <v-col cols="2" align-self="center" class="text-center">
              <v-icon small>fal fa-arrow-right</v-icon>
            </v-col>
            <v-col cols="5">
              <v-menu offset-y full-width
                v-model="config.datepicker"
                transition="scale-transition"
                min-width="290px"
                :close-on-content-click="false"
                :nudge-right="40">
                <template v-slot:activator="{ on }">
                  <v-text-field readonly
                    v-model="printNextDate"
                    v-on="on"
                    label="変更後の予定日"
                    :rules="rules.required"
                    :append-icon="form.nextDate ? 'fal fa-times' : null"
                    @click:append="form.nextDate = ''"
                  />
                </template>
                <v-date-picker
                  v-model="form.nextDate"
                  locale="ja"
                  color="amber"
                  :day-format="date => new Date(date).getUTCDate()"
                  @input="config.datepicker = false"
                />
              </v-menu>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn text color="secondary" @click="close">閉じる</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed color="secondary" @click="submit">更新する</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'clientEventsPosterRescheduler',
  data () {
    return {
      config: {
        status: {
          active: false
        },
        datepicker: false
      },
      form: {
        valid: true,
        prevDate: '',
        nextDate: ''
      },
      rules: {
        required: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    open: function (req) {
      const { date } = req || {}
      this.$set(this, 'form', {
        valid: true,
        prevDate: date || '',
        nextDate: ''
      })
      this.$set(this.config.status, 'active', true)
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
      this.$emit('close')
    },
    submit: function () {
      if (this.$refs.form.validate()) {
        this.$emit('done', {
          type: 'reschedule',
          eventDate: this.form.nextDate
        })
        this.close()
      }
    }
  },
  computed: {
    printPrevDate () {
      return this.$moment(this.form.prevDate).format('YYYY年MM月DD日')
    },
    printNextDate () {
      return this.form.nextDate ? this.$moment(this.form.nextDate).format('YYYY年MM月DD日') : ''
    }
  }
}
</script>